import React from 'react';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from "@material-ui/icons/MoreVert";
import {IconButton} from "@material-ui/core";
import DeleteLearningLibraryItem from "./DeleteLearningLibraryItem";

export default function LearningLibraryItemMenu({learningLibraryItem, deleteLearningLibraryItem}) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [numberOpenClicks, setNumberOpenClicks] = React.useState(0);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div>
            <IconButton size={"small"} onClick={handleClick}><MoreVertIcon/></IconButton>
            <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                <MenuItem onClick={() => {
                    setNumberOpenClicks(numberOpenClicks + 1)
                    handleClose()
                }}>Delete</MenuItem>
            </Menu>
            <DeleteLearningLibraryItem learningLibraryItem={learningLibraryItem} numberOpenClicks={numberOpenClicks} deleteHandler={deleteLearningLibraryItem}/>
        </div>
    );
}
